module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_1_1-9041fa36090d1f177ea80b68f90bd473.png";